import { BaseComponent } from '../../types';
import { Header } from './Header';
import { Footer } from '../Footer/Footer';

interface LayoutProps extends BaseComponent {
  title?: string;
  activePage?: string;
  style?: React.CSSProperties;
}

export function Layout({
  children,
  className,
  title,
  activePage = 'Anasayfa',
  style,
}: LayoutProps) {
  return (
    <div className={`min-h-screen ${className || ''}`} style={style}>
      <Header title={title} activePage={activePage} />
      {children}
      <Footer />
    </div>
  );
}
